export enum CivilStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  WIDOWED = 'WIDOWED',
  DIVORCED = 'DIVORCED',
  PARTNERSHIP = 'PARTNERSHIP',
  SEPARATED = 'SEPARATED'
}
